import axios from 'axios'

function token () {
  return localStorage.getItem('api_token')
}

function url (apiBase) {
  return `${apiBase}/api/branch`
}

export const branchesApi = {
  list: (apiBase, params = {}) => {
    const search = new URLSearchParams({ token: token(), ...params }).toString()
    return axios.get(`${url(apiBase)}?${search}`).then((r) => r.data)
  },
  show: (apiBase, id) => axios.get(`${url(apiBase)}/${id}?token=${token()}`).then((r) => r.data),
  create: (apiBase, payload) => axios.post(`${url(apiBase)}?token=${token()}`, payload).then((r) => r.data),
  update: (apiBase, id, payload) => axios.put(`${url(apiBase)}/${id}?token=${token()}`, payload).then((r) => r.data),
  remove: (apiBase, id) => axios.delete(`${url(apiBase)}/${id}?token=${token()}`).then((r) => r.data),
  salesByBranch: (apiBase, payload) =>
    axios.post(`${url(apiBase)}/sales-by-branch?token=${token()}`, payload).then((r) => r.data),
  salesByState: (apiBase, payload) =>
    axios.post(`${url(apiBase)}/sales-by-state?token=${token()}`, payload).then((r) => r.data),
  overview: (apiBase, payload) =>
    axios.post(`${url(apiBase)}/overview?token=${token()}`, payload).then((r) => r.data),
  insights: (apiBase, id, payload) =>
    axios.post(`${url(apiBase)}/${id}/insights?token=${token()}`, payload).then((r) => r.data),
  leaderboard: (apiBase, payload) =>
    axios.post(`${url(apiBase)}/leaderboard?token=${token()}`, payload).then((r) => r.data),
  entityDetail: (apiBase, payload) =>
    axios.post(`${url(apiBase)}/entity-detail?token=${token()}`, payload).then((r) => r.data),
}

export default branchesApi
